/**
 * It takes a file, a title, and an orderID, and returns a new file with a new name, file type, and a
 * boolean value for whether or not it's a video file
 * @param actualFile - the file that it's going to be uploaded
 * @param titleStory - the title of the story
 * @param orderID - the order id
 * @returns {
 *     newFileName: newFileName,
 *     fileType: fileType,
 *     newFile: newFile,
 *     isVideoFile: isVideoFile,
 *   };
 */

import { getExtensionVideoFile } from "./getExtensionVideoFile";
//import { resizeFile } from "./resizeFile";
export const getNewFile = async (actualFile, titleStory, orderID) => {
  let clearTStory = titleStory.replace(/[^a-zA-Z0-9 ]/g, "");
  let fileName = actualFile.file.name;
  let fileType = actualFile.file.type;
  let fileExtension = fileName.split(".")[1];
  let randomName = Math.random().toString(36).substr(2, 9);
  let removeSpecialChars = fileName.replace(/[^a-zA-Z0-9.]/g, "");
  let newNameSP = removeSpecialChars.split(".")[0];
  let newFileName = "";
  if (!newNameSP || newNameSP === "" || !newNameSP.length) {
    newFileName = orderID + "-" + randomName + "." + fileExtension;
  } else {
    if (clearTStory) {
      newFileName =
        clearTStory + "-" + newNameSP + "-" + randomName + "." + fileExtension;
    } else {
      newFileName = newNameSP + "-" + randomName + "." + fileExtension;
    }
  }
  let isVideoFile = await getExtensionVideoFile(newFileName);
  let newFile = new File([actualFile.file], newFileName, {
    type: fileType,
  });

/* Saving Resize Images if need for future   
  try {
    if (!isVideoFile) {
      newFile = await resizeFile(newFile, fileExtension);
    }
  } catch (error) {
    newFileName = orderID + "-" + randomName + "." + fileExtension;
    newFile = new File([actualFile.file], newFileName, {
      type: fileType,
    });
  } 
*/
  return {
    newFileName: newFileName,
    fileType: fileType,
    newFile: newFile,
    isVideoFile: isVideoFile,
  };
};
